import { Component, EventEmitter, Output, input, computed, signal } from "@angular/core";
import { NotificationService } from "@kno2/common/services";
import { NgxDropzoneChangeEvent } from "ngx-dropzone";

@Component({
    selector: "kno2-file-dropzone",
    templateUrl: "./file-dropzone.component.html",
    standalone: false
})
export class FileDropzoneComponent {
    public acceptedExtensions = input<Array<string>>([]);
    public invalidFormatErrorMessage = input<string>();
    public isRequired = input<boolean>(false);
    public isDropzoneDisabled = input<boolean>(false);

    public extensionsString = computed(() => {
        const exts = this.acceptedExtensions();
        return exts && exts.length > 0 ? exts.join(",") : "*";
    });

    public extensions = computed(() => {
        const exts = this.acceptedExtensions();
        return exts ? exts.map((ext) => ext.toUpperCase()) : [];
    });

    @Output() public filesChanged = new EventEmitter<Array<File>>();
    @Output() public dropzoneClick = new EventEmitter<void>();

    public files = signal<Array<File>>([]);

    constructor(private notificationService: NotificationService) {}

    public onFileAdd(event: NgxDropzoneChangeEvent): void {
        if (event.addedFiles.length) {
            this.files.update((files) => [...files, ...event.addedFiles]);
        }
        if (event.rejectedFiles.length) {
            this.handleRejectedFiles(event.rejectedFiles);
        }
        this.filesChanged.emit(this.files());
    }

    public onFileRemove(file: File): void {
        this.files.update((files) => files.filter((x) => x != file));
        this.filesChanged.emit(this.files());
    }

    public handleRejectedFiles(files: Array<File>): void {
        const invalidFileFormats = files.map((file) => file.name.split(".").pop()).join(", ");
        const toastMsg = this.invalidFormatErrorMessage() || `${files.length} file(s) rejected due to invalid formatting: "${invalidFileFormats}"`;
        this.notificationService.error(toastMsg);
    }

    public onDropzoneClick(): void {
        this.dropzoneClick.emit();
    }
}
